import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  amountCompensationOption: {
    marginTop: '2rem',
  },
  radioButton: {
    color: 'black',
    '&$checked': {
      color: theme.palette.primary.main,
    },
  },
  selectedLabel: {
    color: theme.palette.primary.main,
    fontWeight: 'bold',
  },
  radioButtonWrapper: {
    marginBottom: 10,
  },
  promoCodeError: {
    color: theme.palette.error.main,
    fontSize: 14,
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    width: '100%',
    marginTop: '1.5rem',
    marginBottom: '0.75rem',
  },
  label: {
    fontSize: '16px',
    minWidth: '80px',
  },
}));

export default useStyles;
